import TimooOverview from "@/pages/Timoo/TimooOverview.vue";
import GestioneCredito from "@/pages/Timoo/GestioneCredito.vue";

import { createBreadCrumbs, setNavigator } from "@/router/routerFunction";

export function routesTimoo() {
  return [
    {
      path: "/timoo",
      name: "TimooOverview",
      component: TimooOverview,
      meta: {
        breadcrumbs: [{ name: "timoo", url: "" }],
        indexRoute: "timoo",
        permissions: [],
      },
      beforeEnter: [createBreadCrumbs, setNavigator],
    },
    {
      path: "/timoo-credit",
      name: "GestioneCreditoEn",
      component: GestioneCredito,
      meta: {
        breadcrumbs: [
          { name: "management", url: "" },
          { name: "consumption", url: "" },
          { name: "gestioneCredito", url: "" },
        ],
        indexRoute: "timoo-credit",
        permissions: ["gestione_credito"],
      },
      beforeEnter: [createBreadCrumbs, setNavigator],
    },
    {
      path: "/gestione-credito",
      name: "GestioneCreditoIt",
      component: GestioneCredito,
      meta: {
        breadcrumbs: [
          { name: "management", url: "" },
          { name: "consumption", url: "" },
          { name: "gestioneCredito", url: "" },
        ],
        indexRoute: "gestione-credito",
        permissions: ["gestione_credito"],
      },
      beforeEnter: [createBreadCrumbs, setNavigator],
    },
  ];
}
